import { createContext } from 'react';

const ReviewAlertsScreenContext = createContext( null );

export default ReviewAlertsScreenContext;
